import React, {useState} from 'react'
import {IFields, fieldsInitValues as initialValues} from '../../models/FieldsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
// import makeAnimated from 'react-select/animated'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {PointAdd} from '../../../../../../_metronic/partials/widgets/map/pointAdd'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {Input3} from '../../../../../../components/Forms/Input'
// import { convertToWK } from 'wkt-parser-helper'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const API_URL = process.env.REACT_APP_API_URL || 'api'

const fieldsSchema = Yup.object().shape({})

const FormFieldsAdd: React.FC = () => {
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const formik = useFormik<IFields>({
    initialValues,
    validationSchema: fieldsSchema,
    onSubmit: async (values) => {
      setLoading(true)
      console.log(values)
      try {
        await axios.post(API_URL + '/v1/fields', values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'FIELD.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/fields')
      } catch (error) {
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'FIELD.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  // const animatedComponents = makeAnimated()

  return (
    <div className='card card-custom mt-n8'>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />

      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'FIELD.TITLE_ADD'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='col-lg-7'>

                  <div className='row mb-3'>

                    {/*---------------------- INICIO NOME ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        required
                        title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME_PLACEHOLDER'})}
                        {...formik.getFieldProps('name')}
                      />
                    </div>
                    {/*---------------------- FIM NOME ----------------------*/}


                    {/*---------------------- INICIO ABREVIAÇÃO ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        required
                        title={intl.formatMessage({id: 'COMMON.ABBREVIATION'})}
                        placeholder={intl.formatMessage({id: 'COMMON.ABBREVIATION_PLACEHOLDER'})}
                        {...formik.getFieldProps('abbreviate')}
                      />
                    </div>
                    {/*---------------------- FIM ABREVIAÇÃO ----------------------*/}
                  </div>

                  <div className='row mb-3'>
                    {/*---------------------- INICIO CODIGO DE PRODUÇÃO ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        title={intl.formatMessage({id: 'FIELD.INPUT_PRODUCTION_DEMO_CODE'})}
                        placeholder={intl.formatMessage({id: 'FIELD.INPUT_PRODUCTION_DEMO_CODE_PLACEHOLDER'})}
                        {...formik.getFieldProps('production_demo_code')}
                      />
                    </div>
                    {/*---------------------- FIM CODIGO DE PRODUÇÃO ----------------------*/}


                    {/*---------------------- INICIO REGIAO ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.REGION'})}
                        placeholder={intl.formatMessage({id: 'COMMON.REGION_PLACEHOLDER'})}
                        {...formik.getFieldProps('region')}
                      />
                    </div>

                    {/*---------------------- FIM REGIAO ----------------------*/}
                  </div>


                  {/*---------------------- INICIO CONTRATO CONCESSAO ----------------------*/}
                  <div className='row mb-3'>
                    <div className='col-lg-12'>
                      <Input3
                        title={intl.formatMessage({id: 'FIELD.INPUT_CONCESSION_CONTRACT_NUMBER'})}
                        placeholder={intl.formatMessage({id: 'FIELD.INPUT_CONCESSION_CONTRACT_NUMBER_PLACEHOLDER'})}
                        {...formik.getFieldProps('concession_contract_number')}
                      />
                    </div>
                  </div>
                  {/*---------------------- FIM CONTRATO CONCESSAO ----------------------*/}


                  {/*---------------------- INICIO DESCRIPTION ----------------------*/}
                  <div className='row mb-3'>
                    <label className=' col-form-label fw-bold '>
                      {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                    </label>
                    <div className='col-lg-12'>
                                          <textarea
                                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                              aria-multiline='true'
                                              placeholder={intl.formatMessage({id: 'COMMON.INPUT_DESCRIPTION_PLACEHOLDER'})}
                                              rows={4}
                                              {...formik.getFieldProps('description')}
                                          />
                    </div>


                  </div>
                  {/*---------------------- FIM DESCRIPTION ----------------------*/}

                  {/*---------------------- INICIO SUBMIT ----------------------*/}
                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary  mx-2'>
                      {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
                    </button>
                  </div>
                </div>
                {/*---------------------- FIM SUBMIT ----------------------*/}

                <div className='col-lg-5'>
                  <PointAdd
                    latitude={latitude}
                    longitude={longitude}
                    name={'Novo'}
                    description={'Localização do Novo Empreendimento'}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormFieldsAdd}
